import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginNoHighlightLeftImageInfo } from './PluginNoHighlightLeftImageInfo';
import { PluginNoHighlightLeftImageInfoContent } from './PluginNoHighlightLeftImageInfoContent';
import { PluginNoHighlightLeftImageInfoFigure } from './PluginNoHighlightLeftImageInfoFigure';

type Props = {
  index: number;
  data: PluginNoHighlightLeftImageInfo;
  updateData: (element: IElement, index: number) => void;
};

export const PluginNoHighlightLeftImageInfoFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginNoHighlightLeftImageInfo>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-no-highlight-left-image-info">
          <div className="showcase">
            <PluginNoHighlightLeftImageInfoContent
              data={data}
              update={update}
            />
            <PluginNoHighlightLeftImageInfoFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
